import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { encryptPayload, decryptResponse } from './CryptoUtil';
import { APP_URL, withCredentials } from '../App';

const AppVersion = () => {
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAppVersions = async () => {
      try {
        const userSession = JSON.parse(localStorage.getItem("userSession"));
        if (!userSession) {
          setError("User session not found");
          return;
        }

        const token = decryptResponse(userSession.data.payload, userSession.data.transactionId).token;

        const response = await axios.post(
          `${APP_URL}getAppVersionDevices.php`,
          {},
          {
            withCredentials: withCredentials,
            headers: {
              'Content-Type': 'application/json',
              'X-API-Key': token,
            },
          }
        );

        const decryptText = decryptResponse(response.data.payload, response.data.transactionId);
        setItems(decryptText.items);
      } catch (error) {
        console.error("Error fetching app version details:", error);
        setError("Cannot fetch the data now, please try again");
      }
    };

    fetchAppVersions();
  }, []);

  return (
    <div>
      <div className="row">
        {items.length > 0 ? (
          <div className="col-md-12 grid-margin transparent">
            <div className="card">
              <div className="card-body">
                <h2>Device Version Detail</h2>
                <div className="table-responsive">
                  <table className="table table-striped table-borderless">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>App Version</th>
                        <th>No. of Device</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.appversion}</td>
                          <td>{item.devices}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-md-12 grid-margin transparent">
            <p>{error || "No results found"}</p>
          </div>
        )}
      </div>
    </div>
  );
};

AppVersion.displayName = "AppVersion";
export default AppVersion;
